export default "/static/dashboard/build/app/img/v2/d272fa45cad9577a0c96ff3c7221bcd1.png";